"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraOverlayDrawer = void 0;
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const Icons_1 = require("./Icons");
require("../styles/eura-overlay-drawer.css");
/**
 * EuraOverlay-komponentin kanssa käytettäväksi tarkoitettu Drawer-komponentti.
 * @param props
 * @param props.dataTestId Drawerin aukaisunapin testitunnus
 * @param props.children Drawerin sisältö
 * @param props.buttonText Drawerin aukaisunapin teksti
 * @param props.closeTitle Drawerin sulkemisnapin teksti
 * @param props.tabIndex tabindex
 */
const EuraOverlayDrawer = (props) => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const showDrawer = () => {
        setVisible(true);
    };
    const onClose = () => {
        setVisible(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DrawerButton, { tabIndex: visible === false ? props.tabIndex || 0 : -1, "data-testid": props.dataTestId, onClick: showDrawer },
            react_1.default.createElement(Icons_1.HamburgerIcon, { className: 'eura-overlay-drawer__button-margin' }),
            react_1.default.createElement("span", null, props.buttonText)),
        react_1.default.createElement(EuraDrawer, { "aria-label": props.drawerLabel, role: 'dialog', width: '25rem', closeIcon: react_1.default.createElement(DrawerCloseIcon, null, props.closeTitle), destroyOnClose: true, title: '', placement: 'right', closable: true, onClose: onClose, visible: visible }, react_1.default.Children.map(props.children, (child) => react_1.default.cloneElement(child, { onClose })))));
};
exports.EuraOverlayDrawer = EuraOverlayDrawer;
const EuraOverlayDrawerSubMenuContainer = (props) => {
    return (react_1.default.createElement("div", { onClick: props.handleSubMenuItemClick, className: 'eura-overlay-drawer-submenu__container' }, props.children));
};
/**
 * EuraOverlayDrawer-komponentin kanssa käytettäväksi tarkoitettu alavalikko.
 * @param props
 * @param props.title Valikon otsikko-osion sisältö
 * @param props.children Valikon sisältö
 * @param props.className
 */
const EuraOverlayDrawerSubMenu = (props) => {
    var _a;
    const classConstruct = ['eura-overlay-drawer-submenu', (_a = props.className) !== null && _a !== void 0 ? _a : ''];
    return (react_1.default.createElement("div", { role: props.role || 'navigation', "aria-labelledby": props.id, className: classConstruct.join(' ') },
        react_1.default.createElement("h2", { id: props.id, className: 'eura-overlay-drawer-submenu__title' }, props.title),
        react_1.default.createElement(EuraOverlayDrawerSubMenuContainer, { handleSubMenuItemClick: props.onClose }, props.children)));
};
const DrawerCloseIcon = (props) => {
    return (react_1.default.createElement("div", { className: 'eura-overlay-drawer-header', tabIndex: props.tabIndex },
        react_1.default.createElement("span", null, props.children),
        react_1.default.createElement(Icons_1.CloseIcon, { className: 'eura-close-icon' })));
};
const DrawerButton = (props) => {
    const { className } = props, other = __rest(props, ["className"]);
    const classConstruct = ['eura-overlay-drawer__button', className !== null && className !== void 0 ? className : ''];
    return (react_1.default.createElement("button", Object.assign({ className: classConstruct.join(' ') }, other), props.children));
};
const EuraDrawer = (props) => {
    const { className, contentClassName } = props, other = __rest(props, ["className", "contentClassName"]);
    const classConstruct = ['eura-overlay-drawer', className !== null && className !== void 0 ? className : ''];
    const contentClass = ['eura-overlay-drawer-content', contentClassName !== null && contentClassName !== void 0 ? contentClassName : ''];
    return (react_1.default.createElement(antd_1.Drawer, Object.assign({ className: classConstruct.join(' ') }, other),
        react_1.default.createElement("div", { role: props.role, className: contentClass.join(' ') }, props.children)));
};
exports.EuraOverlayDrawer.CloseIcon = DrawerCloseIcon;
exports.EuraOverlayDrawer.Button = DrawerButton;
exports.EuraOverlayDrawer.Drawer = EuraDrawer;
exports.EuraOverlayDrawer.SubMenu = EuraOverlayDrawerSubMenu;
